import { render, staticRenderFns } from "./allProjects.vue?vue&type=template&id=3da2b78c&"
import script from "./allProjects.vue?vue&type=script&lang=js&"
export * from "./allProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports